import React from 'react';
import ScrollToTop from '../components/ScrollToTop';
import SponsorshipPage from '../components/SponsorshipPage';

function Sponsorship() {
  return (
    <>
      <ScrollToTop />
      <SponsorshipPage />
    </>
  );
}

export default Sponsorship;
